/**
 * Muiha Global JS
 * — Nav scroll behavior (transparent over dark hero → white on scroll)
 * — Fade-up scroll reveals
 */
(function () {
  'use strict';

  /* ─── NAV SCROLL ──────────────────────────────── */
  function initNav() {
    var header = document.getElementById('muiha-header');
    if (!header) return;

    var isOverlay = header.classList.contains('muiha-overlay') ||
                    document.documentElement.hasAttribute('data-muiha-overlay');
    if (!isOverlay) return;

    // Mirror Biomaē pattern: JS owns the class — add immediately, toggle on scroll.
    header.classList.add('muiha-overlay');

    var hero      = document.querySelector('.muiha-hero-overlay');
    var threshold = hero ? Math.max(80, hero.offsetHeight * 0.85) : 80;
    var ticking   = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > threshold) {
            header.classList.remove('muiha-overlay');
          } else {
            header.classList.add('muiha-overlay');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ─── FADE-UP REVEALS ─────────────────────────── */
  function initFadeUp() {
    var elements = document.querySelectorAll('[data-fade-up]');
    if (!elements.length) return;

    elements.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.85s ease, transform 0.85s ease';
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -20px 0px' }
    );

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ─── MOBILE NAV ──────────────────────────────── */
  window.muihaNavOpen = function () {
    var nav = document.getElementById('muiha-mobile-nav');
    if (!nav) return;
    nav.classList.add('open');
    document.body.style.overflow = 'hidden';
    nav._trigger = document.querySelector('.muiha-mobile-toggle');
    var closeBtn = nav.querySelector('.muiha-mobile-close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  };

  window.muihaNavClose = function () {
    var nav = document.getElementById('muiha-mobile-nav');
    if (!nav) return;
    nav.classList.remove('open');
    document.body.style.overflow = '';
    if (nav._trigger) nav._trigger.focus();
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var nav = document.getElementById('muiha-mobile-nav');
      if (nav && nav.classList.contains('open')) window.muihaNavClose();
    }
  });

  /* ─── THEME EDITOR ─────────────────────────────── */
  document.addEventListener('shopify:section:load', function (e) {
    var newEls = e.target.querySelectorAll('[data-fade-up]');
    if (!newEls.length) return;
    newEls.forEach(function (el) {
      el.style.opacity    = '0';
      el.style.transform  = 'translateY(24px)';
      el.style.transition = 'opacity 0.85s ease, transform 0.85s ease';
    });
    setTimeout(function () {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity   = '1';
            entry.target.style.transform = 'translateY(0)';
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -20px 0px' });
      newEls.forEach(function (el) { obs.observe(el); });
    }, 80);
  });

  /* ─── QUICK ADD ───────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.muiha-quick-add-btn');
    if (!btn) return;

    if (btn.classList.contains('muiha-quick-add-sold')) {
      e.preventDefault();
      return;
    }

    if (btn.classList.contains('muiha-quick-add-options')) {
      return; // let parent <a> navigate to PDP
    }

    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = btn.textContent.trim();
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');
      setTimeout(function () {
        btn.textContent = original;
        btn.classList.remove('is-added');
      }, 1800);
    })
    .catch(function () {
      btn.textContent = original;
    });
  });

  /* ─── PROMO BAR ROTATION ──────────────────────── */
  function initPromoBar() {
    var bar = document.querySelector('.muiha-promo-bar');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.mpromo__msg');
    if (msgs.length <= 1) return;
    var speed = parseInt(bar.getAttribute('data-speed') || 5000, 10);
    var current = 0;
    setInterval(function () {
      msgs[current].classList.remove('is-active');
      current = (current + 1) % msgs.length;
      msgs[current].classList.add('is-active');
    }, speed);
  }

  /* ─── INIT ────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initPromoBar();
    setTimeout(initFadeUp, 80);
  });
})();
